import camelCase = require('lodash/camelCase');
import upperCase = require('lodash/upperCase');
import {VideoSettingsLS, IVideoSettings, IVideoSettingsState} from '../../redux/modules/video-settings';
import {History} from 'history';

const normalizeKey = (key: string): string => (
  camelCase(key).replace(/DeviceId|Id/, '')
);

export interface ISettingsChanges {
  videoQuality?: string;
  audioOutput?: string;
  audioInput?: string;
  videoInput?: string;
}

export const getSettingsChanges = (props: IVideoSettings): ISettingsChanges => {
  const prevState: IVideoSettingsState = VideoSettingsLS.get();

  if (!prevState) {
    return {};
  }

  return Object.keys(props)
    .reduce((settings, key) => {
      const name: string = normalizeKey(key);

      if (props[key] !== prevState[key]) {
        settings[name] = `${upperCase(name)} has been changed from ${prevState[key] || 'default'} to ${props[key]}`;
      }

      return settings;
    }, {});
};

export const goHome = (history: History) => history.push('/');
export const goBack = (history: History) => {
  const VIDEO_SETTING_PATH: string = 'video-settings';

  history.goBack();
  history.replace(VIDEO_SETTING_PATH, '');
};
